<template>
  <outro-template status="success" :hide-content="true" :show-exit-button="true">
    <template v-slot:title>
      Déclencher le paiement des heures excédentaires
    </template>
  </outro-template>
</template>

<script>
import OutroTemplate from '@shared/components/OutroTemplate'

export default {
  name: 'Outro',
  components: {
    OutroTemplate
  }
}
</script>

<style lang="scss">

</style>
